import { createSelector } from 'reselect';
import { plannedShapeParameterSelector, kitchenIslandParameterSelector } from 'domain/Options/selectors/parameters';

export const shapeIdSelector = createSelector(
  plannedShapeParameterSelector,
  (plannedShape) => {
    const shape = plannedShape.get('value');
    if (shape) {
      return shape.get('id');
    } else {
      return null;
    }
  }
);

export const kitchenIslandIdSelector = createSelector(
  kitchenIslandParameterSelector,
  (kitchenIslandParameter) => {
    const kitchenIslandValue = kitchenIslandParameter.get('value');
    if (kitchenIslandValue) {
      return kitchenIslandValue.get('id');
    } else {
      return null;
    }
  }
);
